let language = {
    "A1101P400500": "Failed to obtain token user information",
    "A1101B400501": "The interval number of days exceeds the maximum and minimum values",
    "A1101B400502": "Start date with interval days can not be less than current date",
    "A1101B400503": "start date format error",
    "A1101B400504": "interval days is invalid and less than 0",
    "A1101B400505": "Unsupported group order configuration type",
    "A1101B400506": "User does not belong to any partner",
    "A1101B400507": "This partner has no shopowner information",
    "A1101B400508": "interval days are empty",

};

export { language }